import {
  WSCard,
  WSControl,
  WSForm,
  WSInfoBox,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { useCustomization } from "../../../modules/customization";
import { InstantPayoutPayoutCA } from "../../../modules/Settings/components/InstantPayoutPayoutCA";
import { useQueryOwnPayoutSettings } from "@hooks/useQueryOwnPayoutSettings";
import { selectorInstantPayoutFeeLabel } from "@selectors/selectorInstantPayoutFeeLabel";
import { selectorPayoutSettingsInstantFee } from "@selectors/selectorPayoutSettingsInstantFee";

export const IPSupport = () => {
  const queryPayoutSettings = useQueryOwnPayoutSettings();
  const ipFee = selectorPayoutSettingsInstantFee(queryPayoutSettings.data);
  const { support } = useCustomization();

  return (
    <WSCard header="Instant payouts (optional)">
      <WSList gap="XL">
        <WSInfoBox>
          This account may have instant payouts available. Please check your
          financial institution’s online banking portal as some banks may
          require you to opt-in or enable the service manually.
        </WSInfoBox>

        <InstantPayoutPayoutCA />

        <WSList gap="S">
          <WSForm.Field
            name="useAsDefaultIPMethod"
            component={WSControl}
            componentProps={{
              type: "checkbox",
              label: `${selectorInstantPayoutFeeLabel({
                text: "Set instant payout",
                feePercentage: ipFee
              })} as default for all payouts*`
            }}
          />
          <WSText.ParagraphXs color="gray400">
            *Instant payouts allow you to receive payments faster than standard
            payouts for a{ipFee === undefined ? "" : ` ${ipFee}%`} fee. You can
            set instant payout as your default for all payouts or request an
            instant payout on a per invoice basis. These settings can be updated
            in your account settings any time. Instant payouts only work with
            bank accounts or debit cards that participate in instant transfer
            services.
          </WSText.ParagraphXs>
          <WSText.ParagraphXs color="gray400">
            All refunds are processed in accordance with the{" "}
            <a
              href={support(true).documentation.refundPolicyUrl}
              target="_blank"
              rel="noreferrer"
            >
              Refund Policy
            </a>
          </WSText.ParagraphXs>
        </WSList>
      </WSList>
    </WSCard>
  );
};
